/*
 * @Description: 
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-04-22 16:58:46
 * @LastEditors: changfeng
 * @LastEditTime: 2024-04-24 17:29:25
 */
export default {
	"teamSettings.title": "团队设置",
	"teamSettings.tab1": "团队",
	"teamSettings.tab2": "客户",

	"teamSettings.team.rename.modal.title": "修改团队名称",
	"teamSettings.team.rename.modal.label": "团队名称",
	"teamSettings.team.rename.modal.ok": "保存",
	"teamSettings.team.rename.success": "团队名称修改成功",
	"teamSettings.team.invite.button": "邀请团队成员",
	"teamSettings.team.invite.modal.title": "邀请团队成员",
	"teamSettings.team.invite.modal.label": "Email",
	"teamSettings.team.invite.modal.placeholder": "邮箱，空格或逗号分隔",
	"teamSettings.team.invite.modal.ok": "邀请",
	"teamSettings.team.invite.success.message": "已发送邀请",
	"teamSettings.team.invite.pending.text": "（待接受邀请）",
	"teamSettings.team.table.title": "团队成员",
	"teamSettings.team.table.action.remove": "移除",
	"teamSettings.team.table.action.resent": "重新邀请",
	"teamSettings.team.resent.modal.title": "重新邀请",
	"teamSettings.team.resent.modal.text": "您确定要重新发送邀请给 {{email}} 吗？",
	"teamSettings.team.remove.modal.title": "删除 {{email}}？",
	"teamSettings.team.remove.modal.text": "{{email}} 将会被立刻删除，此操作无法撤销。",
	"teamSettings.team.remove.modal.ok": "移除",

	"teamSettings.client.tip": "您可以邀请只能查看电子邮件报告而无权访问您的广告账户的客户",
	"teamSettings.team.tip":
		"您可以邀请成员，这些成员可以完全访问 AdSurgebot 的所有功能和连接的广告账户。但是，成员在升级和账单设置方面将只有有限的访问权限。",
	"teamSettings.client.invite.button": "邀请客户",
	"teamSettings.client.invite.modal.title": "邀请客户",
	"teamSettings.client.invite.modal.email.label": "Email",
	"teamSettings.client.invite.modal.email.placeholder": "客户邮箱",
	"teamSettings.client.invite.modal.name.label": "名称",
	"teamSettings.client.invite.modal.name.placeholder": "全名或公司",
	"teamSettings.client.invite.success.message": "已发送邀请",
	"teamSettings.client.table.title": "客户",
	"teamSettings.client.table.action.remove": "移除"
};
